import { render, staticRenderFns } from "./DigitalNoticeBoardConfig.vue?vue&type=template&id=49cab363&"
import script from "./DigitalNoticeBoardConfig.vue?vue&type=script&lang=js&"
export * from "./DigitalNoticeBoardConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports